export const ProfileChanged = 'ARCADE_CURRENT_PROFILE_CHANGED';
export const LocaleChangeSuccess = '$localeChangeSuccess';
export const LocaleChangeError = '$localeChangeError';
export const ResetFocus = 'ARCADE_RESET_FOCUS';
export const HeartbeatSuccess = 'HEARTBEAT_SUCCESS';
